import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import PGLogo from "../../components/logo/PGLogo";
import { ROUTES } from "../../helpers/constants";

const LOGIN_BG = "/wp-content/themes/pgm/dist/images/login-bg.png";
const LOGIN_BG_FULL = "/wp-content/themes/pgm/dist/images/login-bg-croppedFull.png";

const Sidebar: React.FC = () => {
    const isWide = useMediaQuery("(min-width: 2000px)");

    return (
        <div
            className="pg-login-screen__sidebar"
            style={{
                background: `url(${isWide ? LOGIN_BG_FULL : LOGIN_BG}) no-repeat`,
                backgroundSize: "cover",
            }}
        >
            <PGLogo color="white" href={ROUTES.HOME} width={300} />
            <div className="pg-login-screen__sidebar-quote">
                <span className="pg-login-screen__sidebar-quote-huge">
                    &ldquo;The best all-in-one golf training system&rdquo;
                </span>
                <span className="pg-login-screen__sidebar-quote-name">
                    Martin Chuck
                </span>
                <span className="pg-login-screen__sidebar-quote-title">
                    Golf Digest Top 10 Instructor
                </span>
            </div>
        </div>
    );
};

export default Sidebar;
